var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    className: "eaa1",
    style: {
      color: "var(--ozTextSecondary)"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 5a2 2 0 100-4 2 2 0 000 4zM18 12v-1.22a13.8 13.8 0 003.47 3.068 1 1 0 001.06-1.696c-1.85-1.157-3-2.539-3.684-3.623a9.462 9.462 0 01-.707-1.335c-.235-.552-.412-1.21-1.16-1.194H14a.98.98 0 00-.707.293l-3 3a1 1 0 00-.242.39l-1 3a1 1 0 001.898.633l.925-2.776L13 9.414V12.5a4 4 0 001.6 3.2l2.127 1.595a2 2 0 01.657.857l1.688 4.22a1 1 0 001.857-.743l-1.688-4.22a4 4 0 00-1.314-1.714L15.8 14.1a2 2 0 01-.8-1.6V8h1v4a1 1 0 102 0z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.857 17.515a1 1 0 00-1.714-1.03l-3 5a1 1 0 101.714 1.03l3-5zM9.555 15.168a1 1 0 01.277 1.387l-4 6a1 1 0 01-1.148.394l-3-1a1 1 0 01-.516-1.504l2-3A1 1 0 014 17h3.131l1.037-1.555a1 1 0 011.387-.277zM5.798 19H4.535l-.977 1.465 1.034.345L5.798 19z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.c5539b09.svg";
export { ForwardRef as ReactComponent };